export function isBrowser(deviceDetector) {
  'ngInject';

  return {
    link: link,
    priority: 1100,
    restrict: 'A',
    terminal: true,
    transclude: 'element',
    multiElement: true,
    $$tlb: true // eslint-disable-line angular/no-private-call
  };

  function link($scope, $element, $attr, ctrl, $transclude) {
    let cloneElement = null;
    let cloneScope = null;

    // When the model changes, adjust the element existence.
    $scope.$watch($attr.isBrowser, (isBrowser) => {
      if (!isBrowser) {
        return;
      }

      // If we have an existing item, remove it.
      if (cloneElement) {
        cloneScope.$destroy();
        cloneScope = null;
        cloneElement.remove();
        cloneElement = null;
      }

      // If the new value is truthy, inject the element.
      let detector = isBrowser.split(' ');
      if (detector.indexOf(deviceDetector.browser) > -1) {
        cloneScope = $scope.$new();
        cloneElement = $transclude(
          cloneScope,
          (clone) => $element.after(clone)
        );
      }
    });
  }
}
